import { Box, Progress } from "@chakra-ui/react";
import React from "react";

import { ChakraText } from "components/ChakraText";

import { passwordStrengthPolicy } from "../application/utils/passwordStrengthPolicy";
import { PasswordStrength } from "../application/types/PasswordStrength";

interface IProps {
  password: string;
}

const PasswordStrengthBar = ({ password }: IProps) => {
  const passwordStrength = passwordStrengthPolicy(password);

  return (
    <Box>
      <Progress
        size="xs"
        value={calculateValue(passwordStrength)}
        colorScheme={strengthColor(passwordStrength)}
        isAnimated
      />
      <ChakraText>{strengthTitle(passwordStrength)}</ChakraText>
    </Box>
  );
};

const calculateValue = (strength: PasswordStrength) => {
  switch (strength) {
    case PasswordStrength.PowerStrong:
      return 100;
    case PasswordStrength.PowerMedium:
      return 66;
    case PasswordStrength.PowerWeak:
      return 33;
    default:
      return 3;
  }
};

const strengthTitle = (strength: PasswordStrength) => {
  switch (strength) {
    case PasswordStrength.PowerStrong:
      return "Silne hasło";
    case PasswordStrength.PowerMedium:
      return "Średnie hasło";
    case PasswordStrength.PowerWeak:
      return "Słabe hasło";
    default:
      return "Bardzo słabe hasło";
  }
};

const strengthColor = (strength: PasswordStrength) => {
  switch (strength) {
    case PasswordStrength.PowerStrong:
      return "green";
    case PasswordStrength.PowerMedium:
      return "yellow";
    case PasswordStrength.PowerWeak:
      return "orange";
    default:
      return "red";
  }
};

export { PasswordStrengthBar };
